import { AttendanceData, mapAttendanceDatas } from "./AttendanceData";

/* ******************************************************* Attendance site view */
export interface AttendanceSiteView {
    date?: string;
    data_count?: number;
    data?: AttendanceData[];
}

export const mapAttendanceSiteView = (siteData: any): AttendanceSiteView => {
    if (!siteData) {
        throw new Error('Invalid Data')
    }

    const response: AttendanceSiteView = {
        date: siteData.date,
        data_count: siteData.data_count,
        data: Array.isArray(siteData.data) ? mapAttendanceDatas(siteData.data) : []
    }

    return response;
}

export const mapAttendanceSiteViews = (data: any[]): AttendanceSiteView[] => {
    if (!Array.isArray(data)) {
        throw new Error('Invalid Data');
    }

    return data.map(mapAttendanceSiteView);
}
/* ******************************************************* */
